function u() {
  return typeof window < "u";
}
function a(n) {
  return d(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function r(n) {
  var e;
  return (n == null || (e = n.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function S(n) {
  var e;
  return (e = (d(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : e.documentElement;
}
function d(n) {
  return u() ? n instanceof Node || n instanceof r(n).Node : !1;
}
function D(n) {
  return u() ? n instanceof Element || n instanceof r(n).Element : !1;
}
function y(n) {
  return u() ? n instanceof HTMLElement || n instanceof r(n).HTMLElement : !1;
}
function s(n) {
  return !u() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof r(n).ShadowRoot;
}
const N = /* @__PURE__ */ new Set(["inline", "contents"]);
function m(n) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: i,
    display: t
  } = b(n);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + o) && !N.has(t);
}
function C() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const h = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function E(n) {
  return h.has(a(n));
}
function b(n) {
  return r(n).getComputedStyle(n);
}
function g(n) {
  if (a(n) === "html")
    return n;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    s(n) && n.host || // Fallback.
    S(n)
  );
  return s(e) ? e.host : e;
}
function w(n) {
  const e = g(n);
  return E(e) ? n.ownerDocument ? n.ownerDocument.body : n.body : y(e) && m(e) ? e : w(e);
}
function l(n, e, o) {
  var i;
  e === void 0 && (e = []), o === void 0 && (o = !0);
  const t = w(n), p = t === ((i = n.ownerDocument) == null ? void 0 : i.body), c = r(t);
  if (p) {
    const f = v(c);
    return e.concat(c, c.visualViewport || [], m(t) ? t : [], f && o ? l(f) : []);
  }
  return e.concat(t, l(t, [], o));
}
function v(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
export {
  b as getComputedStyle,
  S as getDocumentElement,
  v as getFrameElement,
  w as getNearestOverflowAncestor,
  a as getNodeName,
  l as getOverflowAncestors,
  g as getParentNode,
  r as getWindow,
  D as isElement,
  y as isHTMLElement,
  E as isLastTraversableNode,
  d as isNode,
  m as isOverflowElement,
  s as isShadowRoot,
  C as isWebKit
};
